/**
 * 
 */
class ViewportManager {

	/**
	 * 
	 */
	static viewportCurrent = '';

	/**
	 * 
	 */
	static viewportDefault = wmuwpb.attributeSwitcher.defaultViewport;

	/**
	 * 
	 */
	static viewportPrevious = '';

	/**
	 * 
	 */
	static viewports = wmuwpb.attributeSwitcher.viewports;

	/**
	 * 
	 */
	static calculateViewportCurrent()
	{
		for ( const key of Object.getOwnPropertyNames( ViewportManager.viewports ) )
		{
			if (
				window.innerWidth >= ViewportManager.viewports[ key ].sizes.min
				&& (
					window.innerWidth <= ViewportManager.viewports[ key ].sizes.max
					|| -1 === ViewportManager.viewports[ key ].sizes.max
				)
			)
			{
				return key;
			}
		}

		return ViewportManager.defaultViewport;
	}

	/**
	 * 
	 */
	static check()
	{
		const viewportCalculate = ViewportManager.calculateViewportCurrent();

		if ( viewportCalculate !== ViewportManager.viewportCurrent )
		{
			ViewportManager.viewportPrevious = ViewportManager.viewportCurrent;
			ViewportManager.viewportCurrent = viewportCalculate;

			const event = new CustomEvent( 'WMUViewportChange', { 
				detail: {
					currentViewport: ViewportManager.viewportCurrent,
					previousViewport: ViewportManager.viewportPrevious
				}
			} );
			document.dispatchEvent( event );

			/**
			 * Backwards compatibility
			 */
			wmuwpb.attributeSwitcher.currentViewport = viewportCalculate;
		}
	}

	/**
	 * 
	 * @return String
	 */
	static getCurrentViewport()
	{
		return ViewportManager.viewportCurrent.toLowerCase() || ViewportManager.viewportDefault.toLowerCase();
	}

}

export default ViewportManager;